import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import KanbanBoard from './components/KanbanBoard';
import ProjectsList from './components/ProjectsList';
import ProjectsMap from './components/ProjectsMap';
import ProjectsPipeline from './components/ProjectsPipeline';
import ProjectDetail from './components/ProjectDetail';
import AdminUsersPage from './components/AdminUsersPage';
import AdminSettingsPage from './components/AdminSettingsPage';
import DataExportImport from './components/DataExportImport';
import UserProfile from './components/UserProfile';
import PendingUsersPage from './components/PendingUsersPage';
import TaskManagement from './components/TaskManagement';
import GoogleDriveSetup from './components/GoogleDriveSetup';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={!user ? <LoginPage /> : <Navigate to="/dashboard" />} 
      />
      <Route 
        path="/reset-password" 
        element={!user ? <ResetPassword /> : <Navigate to="/dashboard" />} 
      />
      <Route 
        path="/dashboard" 
        element={user ? <Dashboard /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/kanban" 
        element={user ? <KanbanBoard /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/projects-list" 
        element={user ? <ProjectsList /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/map" 
        element={user ? <ProjectsMap /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/pipeline" 
        element={user ? <ProjectsPipeline /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/project/:id" 
        element={user ? <ProjectDetail /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/projects/:id" 
        element={user ? <ProjectDetail /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/admin/users" 
        element={user ? <AdminUsersPage /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/admin/settings" 
        element={user ? <AdminSettingsPage /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/admin/data-management" 
        element={user ? <DataExportImport /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/admin/google-drive" 
        element={user ? <GoogleDriveSetup /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/profile" 
        element={user ? <UserProfile /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/admin/pending-users" 
        element={user ? <PendingUsersPage /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/tasks" 
        element={user ? <TaskManagement /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/" 
        element={user ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} 
      />
    </Routes>
  );
}

export default App;